import { Filter, useAggregateContexts } from '@ilteducation/content-search';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useCategories } from '@ilteducation/content-ref-data';
import orderBy from 'lodash/orderBy';

export default () => {
  const aggregationContextStore = useAggregateContexts('Video');
  const { aggregate, createAggrId } = aggregationContextStore;

  const { context, isLoading } = storeToRefs(aggregationContextStore);

  const aggrParams: [string[], Filter] = [['categories'], {}];
  const aggrId = createAggrId(...aggrParams);
  const subjectAggregationResult = computed(() => context.value(aggrId));

  if (!subjectAggregationResult.value && !isLoading.value(aggrId)) {
    aggregate(...aggrParams);
  }

  const { categories } = useCategories();

  const subjectsWithVideos = computed(() =>
    orderBy(
      categories.value.filter((subject) =>
        subjectAggregationResult.value?.aggregation
          .find((aggr) => aggr.field === 'categories')
          ?.counts.find((count) => count.key === subject.id && count.count >= 1),
      ),
      'category',
    ).filter((c) => c.kind === 'subject'),
  );

  const isSecondarySchoolProgram = (subjectSlug: string) => {
    return ['barn-och-fritid', 'fordon-och-transport', 'vard-och-omsorg'].includes(subjectSlug);
  };
  return {
    subjectsWithVideos,
    isSecondarySchoolProgram,
    isLoading,
  };
};
